/**
 * Closed sets shared by the database (enum types in supabase/migrations), both
 * apps and the i18n files. Changing a value here means a new migration and an
 * update to src/i18n/en.json and src/i18n/es.json in the same commit.
 */

export const CONDITIONS = ['H', 'S', 'D', 'NF'] as const;
export type Condition = (typeof CONDITIONS)[number];

export const TREE_STATUSES = ['active', 'dead', 'replaced', 'not_found'] as const;
export type TreeStatus = (typeof TREE_STATUSES)[number];

export const SPECIES_TYPES = ['fruit', 'hardwood', 'other'] as const;
export type SpeciesType = (typeof SPECIES_TYPES)[number];

export const SOIL_MOISTURE = ['dry', 'moist'] as const;
export type SoilMoisture = (typeof SOIL_MOISTURE)[number];

export const SOIL_TEMP = ['cool', 'warm'] as const;
export type SoilTemp = (typeof SOIL_TEMP)[number];

export const HEIGHT_METHODS = ['tape', 'pole', 'clinometer', 'estimate'] as const;
export type HeightMethod = (typeof HEIGHT_METHODS)[number];

/** Observation chips — the worksheet's free-text "Observations" made countable. */
export const OBSERVATION_CHIPS = [
  'dry_leaves',
  'leafcutter_ants',
  'other_insects',
  'grazed',
  'broken_stem',
  'fire_damage',
  'weeds',
  'no_mulch',
  'standing_water',
  'other',
] as const;
export type ObservationChip = (typeof OBSERVATION_CHIPS)[number];

export const WEATHER_CHIPS = ['sunny', 'cloudy', 'rain', 'windy', 'hot', 'cool'] as const;
export type WeatherChip = (typeof WEATHER_CHIPS)[number];

export const INTERVENTION_TYPES = [
  'watered',
  'mulched',
  'bottle_drip',
  'fertilizer',
  'ant_control',
  'staked',
  'guard',
  'pruned',
  'replaced',
] as const;
export type InterventionType = (typeof INTERVENTION_TYPES)[number];

/** Units an intervention quantity may carry. */
export const INTERVENTION_UNITS = ['L', 'kg', 'count'] as const;
export type InterventionUnit = (typeof INTERVENTION_UNITS)[number];

export const MEDIA_KINDS = ['photo', 'video', 'drone', 'other'] as const;
export type MediaKind = (typeof MEDIA_KINDS)[number];

export const ROLES = ['admin', 'lead', 'field', 'viewer'] as const;
export type Role = (typeof ROLES)[number];
